<template>
  <div class="menuBox">
    <div class="menuUser">
      <div class="eicon">
        <img v-if="companyName && companyName != '浙江中智'" alt="jg" class="eiconimg" src="../../assets/photo/jg.png">
        <img v-if="companyName && companyName == '浙江中智'" alt="ciic" class="eiconimg"
             src="../../assets/photo/ciic.png">
      </div>
      <div class="together">
        <Tooltip :content="companyName">
          <p class="togetherName">{{ companyName }}</p>
        </Tooltip>
      </div>
    </div>
    <div class="menuTable">
      <div class="sider-menu">
        <Menu ref="side_menu" :accordion="true" :active-name="activeName" :open-names="openNames" theme="light"
              width="220" @on-select="menuSlected">
          <MenuItem name="homeContent">首页</MenuItem>
          <template v-for="(item,index) in menuList">
            <template v-if="item.children.length == 0">
              <MenuItem :key="'item' + index" :name="item.name">{{ item.title }}</MenuItem>
            </template>
            <template v-else>
              <Submenu :key="index" :name="item.name">
                <template slot="title">{{ item.title }}</template>
                <template v-for="(item2,index) in item.children">
                  <MenuItem :name="item2.name"><span class="menudian"></span>{{ item2.title }}</MenuItem>
                </template>
              </Submenu>
            </template>
          </template>
        </Menu>
      </div>
    </div>
  </div>
</template>

<script>
import {loginCompanyName, logout} from '@/api/login.js'

export default {
  name: 'tableMenu',
  data() {
    return {
      menuList: [],
      openNames: [],
      companyName: ''
    }
  },
  computed: {
    activeName() {
      if (this.$route.path.split('/').slice(1).length >= 3) {
        return this.$route.path.split('/').slice(1)[1]
      }
      return this.$route.name
    }
  },
  // 导航栏回显
  mounted() {
    this.getMenuList()
    this.init()
  },
  methods: {
    init() {
      loginCompanyName().then(res => {
        this.companyName = res.data.data
      })
    },
    menuSlected(name) {
      if (Boolean(name) && this.$route.name !== name) {
        this.$router.push({name})
      }
    },
    getMenuList() {
      this.$http.get('system/auth/login/roleMenu').then((res) => {
        this.menuList = res.data.data
        localStorage.setItem('routerList', JSON.stringify(this.menuList))
        if (this.$route.path.split('/').length >= 3) {
          this.openNames = this.$route.path.split('/').slice(1, this.$route.path.split('/').length - 1)
        }
        this.$nextTick(() => {
          this.$refs.side_menu.updateOpened()
          this.$refs.side_menu.updateActiveName()
        })
      })
    },
    // 跳转个人中心，修改密码
    jumpTo(val) {
      this.$router.push({name: val})
    },
    //退出
    goOut() {
      this.$Modal.confirm({
        title: '确认退出？',
        onOk: () => {
          logout().then((res) => {
            this.$Message.success(res.data.msg)
            this.$router.push({name: 'login'})
          }).catch(() => {
            this.$Message.error('退出失败')
          })
        },
        onCancel: () => {
          this.$Message.info('已取消退出')
        }
      })
    }
  }
}
</script>

<style lang='less' scoped>
.menuBox {

  .menuUser {
    height: 140px;
    width: 100%;
    background: #fff;
    text-align: center;
    margin-bottom: 10px;
    padding-top: 20px;

    /deep/ .ivu-tooltip-light.ivu-tooltip-popper[x-placement=bottom-start] .ivu-tooltip-arrow {
      left: 36px !important;
    }

    .eicon {
      width: 70px;
      height: 70px;
      border-radius: 5px;
      background-color: #ffffff;
      margin-left: 75px;

      .eiconimg {
        width: 50px;
        height: 50px;
        margin-top: 10px;
      }
    }

    .userImg {
      width: 80px;
      height: 80px;
      line-height: 80px;
      margin-top: 13px;
      margin-bottom: 10px;
    }

    /deep/ .ivu-avatar-large.ivu-avatar-icon {
      font-size: 50px;
    }

    .userName {
      font-size: 14px;
      margin: 8px 0 4px 0;
    }

    .together {
      // display: flex;
      // cursor: pointer;
      font-size: 15px;

      .togetherNameImg {
        width: 20px;
        height: 20px;
        transform: translateY(-10px);
      }

      .togetherName {
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        line-clamp: 1;
        -webkit-box-orient: vertical;
        width: 150px;
        line-height: 40px;

        .togetherNameImg {
          width: 20px;
          height: 20px;
          transform: translateY(5px);
        }
      }

      /deep/ .ivu-tooltip-inner {
        max-width: 110px;
        white-space: inherit;
      }
    }

    /deep/ .ivu-tooltip-popper {
      /* 权限下拉位置 */
      left: 65px !important;
    }

    /deep/ .ivu-tooltip-inner {
      /* 权限下拉 */
      padding: 0.63rem;
    }

    .ivu-divider-horizontal {
      margin: 0.3rem 0;
    }

    .tooltipTitle {
      padding: 0 8px;
      cursor: pointer;
      line-height: 25px;

      .enterprisechake {
        width: 250px;
        height: 60px;
        padding: 5px;
        margin-bottom: 10px;
        display: flex;
        align-items: flex-start;
        flex-direction: row;

        img {
          width: 45px;
          height: 45px;
          margin-right: 5px;
        }
      }

      .addenterprise {
        width: 250px;
        height: 40px;
        border: #f2f2f2 1px solid;
        border-radius: 5px;
        text-align: center;
        line-height: 40px;

        img {
          width: 20px;
          height: 20px;
        }
      }
    }
  }

  .menuTable {
    height: 100%;
    background-color: #ffffff;
    padding-bottom: 160px;
    overflow: auto;
    width: 220PX;

    .sider-menu {
      /deep/ .ivu-menu-submenu-title, .ivu-menu-item {
        height: 50px;
        line-height: 50px;
        font-size: 14px;
        padding: 0 20px;
        color: #151e26;
      }

      /deep/ .ivu-menu-item:hover {
        color: rgb(39, 166, 184) !important;
      }

      .ivu-menu-submenu {
        /deep/ .ivu-menu-item {
          height: 40px;
          line-height: 40px;
          // padding: 0 40px;
          padding-left: 34px !important;
          color: rgb(191, 203, 217);
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        /deep/ .ivu-menu-item:hover {
          color: rgb(39, 166, 184) !important;
          background: linear-gradient(270deg, rgba(43, 190, 173, 0.1) 0%, rgba(35, 147, 193, 0.1) 100%) !important;

          .menudian {
            background: linear-gradient(270deg, #2bbead 0%, #2393c1 100%);
          }
        }
      }

      .menudian {
        display: inline-block;
        width: 7px;
        height: 7px;
        background: #b8bbbd;
        border-radius: 50%;
        margin-right: 14px;
      }

      .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) .menudian {
        background: linear-gradient(270deg, #2bbead 0%, #2393c1 100%);
      }

      /*选中后点的颜色*/

      /deep/ .ivu-menu-vertical.ivu-menu-light:after {
        width: 0;
      }
    }

    .ivu-menu-light {
      z-index: 1;
      padding-bottom: 10px;
    }
  }

  .menuTable::-webkit-scrollbar {
    display: none;
  }
}
</style>
